<template>
  <div v-if="show">
    <loading :loading="loading"></loading>
    <error-alert-item
      :logout-on-network-error="false"
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="validateLeadData"
      ></refresh-item>

    <div
      class="margin_top_20"
      v-if="showLoginAgain">
      <weex-text
        class="item-heading margin-left-10 margin-right-10"
        v-html="loginAgainMessage"
        ></weex-text>

      <wxc-button
        text="Go to Login Page"
        class="horizontal_center margin_top_40"
        type="blue"
        @wxcButtonClicked="onLoginAgain"
        ></wxc-button>
    </div>

    <div v-if="showSecondaryMobileNumberRequired">
      <weex-text
        class="item-heading margin-left-10 margin-right-10"
        v-html="secondaryMobileNumberRequiredMessage"
        ></weex-text>

      <div class="input_container">
        <weex-text class="input_label">Mobile Number</weex-text>
        <div class="item-phone-number-input-container margin-top-5">
          <phone-code-item :enabled-phone-code-selection="false"></phone-code-item>
          <input
            class="item-phone-number-input"
            :value="secondaryMobileNumber"
            maxlength="10"
            @input="secondaryMobileNumber=$event.target.value"
            type="number"/>
        </div>
      </div>

      <wxc-button
        text="Send Link"
        class="horizontal_center margin_top_40"
        type="blue"
        @wxcButtonClicked="onSendLinkOnSecondaryMobile"
        ></wxc-button>

      <weex-text class="margin_top_20 text-align-center font-weight-bold text-color-gray">-OR-
      </weex-text>

      <wxc-button
        text="Continue with Same Mobile Number"
        class="horizontal_center margin_top_20"
        type="blue"
        @wxcButtonClicked="onLeadDataValid"
        ></wxc-button>
    </div>

    <div v-if="showContinueOnSameDevice">
      <weex-text
        class="item-heading margin-left-10 margin-right-10"
        v-html="showContinueOnSameDeviceMessage"
        ></weex-text>

      <wxc-button
        text="Continue on Same Device"
        class="horizontal_center margin_top_40"
        type="blue"
        @wxcButtonClicked="onContinueOnSameDevice"
        ></wxc-button>

      <weex-text class="margin_top_20 text-align-center font-weight-bold text-color-gray">-OR-
      </weex-text>

      <wxc-button
        text="Dismiss"
        class="horizontal_center margin_top_20"
        type="blue"
        @wxcButtonClicked="onDismiss"
        ></wxc-button>
    </div>
  </div>
</template>

<script>
  import Loading from "./Loading";
  import ErrorAlertItem from "./ErrorAlertItem";
  import PhoneCodeItem from "./PhoneCodeItem";
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import AlertService from "../core/alert/AlertService";
  import DataSource from "../../data/DataSource";
  import RefreshItem from "./RefreshItem";
  import EzUtils from "../../utils/EzUtils";
  import { DataTables } from "../../utils/DataTables";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";

  const INVALID_PHONE_NUMBER_MESSAGE = "Please enter valid Mobile Number";
  const SHOULD_BE_DIFFERENT_MOBILE = "Please enter different Mobile Number from your Mobile Number";

  export default {
    name: "LeadDataCheckItem",
    components: { Loading, ErrorAlertItem, WxcButton, RefreshItem, PhoneCodeItem },
    data: () => ({
      leadDetails: {},
      appUserIdInLead: -1,
      loading: false,
      errorAlertEvent: false,
      networkError: {},
      showLoginAgain: false,
      loginAgainMessage: "",
      showRefreshItem: false,
      leadId: -1,
      mobileNumber: "",
      showSecondaryMobileNumberRequired: false,
      secondaryMobileNumberRequiredMessage: "",
      secondaryMobileNumber: "",
      showContinueOnSameDevice: false,
      showContinueOnSameDeviceMessage: ""
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      showError(error) {
        this.loading = false;
        this.networkError = error;
        this.errorAlertEvent = true;
      },

      onLoginAgain() {
        this.$emit("onLoginAgain");
      },

      onLeadDataValid() {
        this.$emit("onLeadDataValid", this.leadDetails);
      },

      onContinueOnSameDevice() {
        this.$emit("onContinueOnSameDeviceWithSecondaryMobile", this.secondaryMobileNumber);
      },

      onDismiss() {
        this.$emit("onDismiss");
      },

      validateLeadData() {
        this.resetData();
        this.loading = true;
        DataSource.getLeadDetailsWithAccessCheck(this.leadId, this.mobileNumber)
          .then(leadDetailsRes => {
            this.loading = false;
            if (leadDetailsRes.errorOccurred) {
              this.showError(leadDetailsRes.data);
              this.showRefreshItem = true;
            } else {
              const leadValidationData = leadDetailsRes.data;
              if (leadValidationData.allowed) {
                this.leadDetails = leadValidationData.lead;
                if (this.leadDetails) {
                  this.appUserIdInLead = this.leadDetails.appuser_id;
                  if (this.mobileNumber === this.leadDetails.secondary_mobile) {
                    LoanScopeDataHolder.setFillClientDetailsWithLeadData(false);
                  } else {
                    LoanScopeDataHolder.setFillClientDetailsWithLeadData(true);
                  }
                }
                this.checkIfSecondaryMobileIsRequired();
              } else {
                this.resetUI();
                this.loginAgainMessage = leadValidationData.errorMessage;
                this.showLoginAgain = true;
              }
            }
          });
      },

      checkIfSecondaryMobileIsRequired() {
        this.loading = true;
        DataSource.isSecondaryMobileRequired(this.leadId, this.mobileNumber)
          .then(secondaryMobileRequiredRes => {
            this.loading = false;
            if (secondaryMobileRequiredRes.errorOccurred) {
              this.showError(secondaryMobileRequiredRes.data);
              this.showRefreshItem = true;
            } else {
              const secondaryMobileRequiredData = secondaryMobileRequiredRes.data;
              if (secondaryMobileRequiredData.secondaryNumberRequired) {
                this.resetUI();
                this.secondaryMobileNumberRequiredMessage = secondaryMobileRequiredData.message;
                this.showSecondaryMobileNumberRequired = true;
              } else {
                this.onLeadDataValid();
              }
            }
          })
      },

      onSendLinkOnSecondaryMobile() {
        if (this.checkForValidationForSecondaryMobile()) {
          const data = { secondary_mobile: this.secondaryMobileNumber };
          this.loading = true;
          DataSource.updateDataTableEntryInMultiRowDataTable(
            DataTables.LEAD,
            this.appUserIdInLead,
            this.leadId,
            data
          )
            .then(updateRes => {
              if (updateRes.errorOccurred) {
                this.showError(updateRes.data);
              } else {
                DataSource.sendLeadLinkOnSecondaryMobile(this.leadId)
                  .then(linkSendRes => {
                    this.loading = false;
                    if (linkSendRes.errorOccurred) {
                      this.showError(linkSendRes.data);
                    } else {
                      this.resetUI();
                      this.showContinueOnSameDeviceMessage = linkSendRes.data.message;
                      this.showContinueOnSameDevice = true;
                    }
                  })
              }
            })
        }
      },

      checkForValidationForSecondaryMobile() {
        if (!EzUtils.validatePhoneNumber(this.secondaryMobileNumber)) {
          this.showToast(INVALID_PHONE_NUMBER_MESSAGE);
          return false;
        }

        if (this.mobileNumber === this.secondaryMobileNumber) {
          this.showToast(SHOULD_BE_DIFFERENT_MOBILE);
          return false;
        }

        return true;
      },

      checkForLeadDataValidation(leadId, mobileNumber) {
        this.resetData();
        this.leadId = leadId;
        this.mobileNumber = mobileNumber;
        this.validateLeadData();
      },

      resetUI() {
        this.showRefreshItem = false;
        this.showLoginAgain = false;
        this.showSecondaryMobileNumberRequired = false;
        this.showContinueOnSameDevice = false;
      },

      resetData() {
        this.resetUI();
        this.leadDetails = {};
        this.appUserIdInLead = -1;
        this.loading = false;
        this.errorAlertEvent = false;
        this.networkError = {};
        this.loginAgainMessage = "";
        this.secondaryMobileNumberRequiredMessage = "";
        this.secondaryMobileNumber = "";
        this.showContinueOnSameDeviceMessage = "";
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
